import { useMemo } from 'react';

import { type AppNotification, deriveNotifications } from '@escala/domain/notifications';
import { useStore } from '@/store/AppStore';

/** Notificações do perfil atual, com o estado de leitura. */
export function useNotifications(): { items: (AppNotification & { unread: boolean })[]; unread: number } {
  const { state, permissions, lookup, today } = useStore();

  return useMemo(() => {
    const read = new Set(state.readNotifications);
    const items = deriveNotifications(state, permissions, lookup, today).map((n) => ({
      ...n,
      unread: !read.has(n.id),
    }));

    return { items, unread: items.filter((n) => n.unread).length };
  }, [lookup, permissions, state, today]);
}
